import { ExportToCsv, Options } from 'export-to-csv';

import { Action, ActionResponse } from './action';

class DownloadCsv implements Action {
  id = 'download_csv';
  label = 'Download CSV';
  options: Options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useTextFile: false,
    useBom: false,
    useKeysAsHeaders: true,
  };

  constructor(filename: string) {
    this.options.filename = filename;
  }

  execute(input: any): ActionResponse {
    if (Array.isArray(input) && input.length === 0) {
      return new ActionResponse({ success: false, message: 'No data available to download' });
    }

    const csvExporter = new ExportToCsv(this.options);
    csvExporter.generateCsv(input);
    return ActionResponse.OK;
  }
}

export default DownloadCsv;
